var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpoStackplan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c7fc55eb-3886-48ce-8fd1-762ee8d211d6",
    "data-name": "art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c22023ee-2693-41c0-84cc-a586385c8dad",
    x1: 25.87,
    y1: 107.04,
    x2: 83.87,
    y2: 49.04,
    gradientTransform: "translate(0 105) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-05e87961-2232-4ca9-ba60-24829db0e2ba",
    x1: 21.21,
    y1: 97.7,
    x2: 90.87,
    y2: 28.04,
    xlinkHref: "#uuid-c22023ee-2693-41c0-84cc-a586385c8dad"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-b6d3c9f4-fc7f-485e-9202-a1d58225cec9",
    x1: 28.09,
    y1: 42.09,
    x2: 62.91,
    y2: 76.91,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#uuid-c22023ee-2693-41c0-84cc-a586385c8dad"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m75.5,63.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-c22023ee-2693-41c0-84cc-a586385c8dad)",
    opacity: 0.25,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68.5,70.5h-5v-27c0-1.1-.9-2-2-2h-27v-5c0-1.1.9-2,2-2h32c1.1,0,2,.9,2,2v32c0,1.1-.9,2-2,2Z",
    fill: "url(#uuid-05e87961-2232-4ca9-ba60-24829db0e2ba)",
    opacity: 0.5,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m61.5,41.5H29.5c-1.1,0-2,.9-2,2v32c0,1.1.9,2,2,2h32c1.1,0,2-.9,2-2v-32c0-1.1-.9-2-2-2Zm-3.48,29.52c0,.55-.45,1-1,1h-23.04c-.55,0-1-.45-1-1v-8.86c0-.55.45-1,1-1s1,.45,1,1v7.86h21.04v-10.41h-4.32c-.55,0-1-.45-1-1s.45-1,1-1h4.32v-8.63h-13.95v8.63h4.32c.55,0,1,.45,1,1s-.45,1-1,1h-4.32v6.09c0,.55-.45,1-1,1s-1-.45-1-1v-16.72h-5.09v7.86c0,.55-.45,1-1,1s-1-.45-1-1v-8.86c0-.55.45-1,1-1h23.04c.55,0,1,.45,1,1v23.04Z",
    fill: "url(#uuid-b6d3c9f4-fc7f-485e-9202-a1d58225cec9)",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpoStackplan);
export default __webpack_public_path__ + "static/media/expo_stackplan.8f1e8c36c6da137100610bd836c5ae1b.svg";
export { ForwardRef as ReactComponent };